import { render, staticRenderFns } from "./RefSelector.vue?vue&type=template&id=787eef34"
import script from "./RefSelector.vue?vue&type=script&lang=js"
export * from "./RefSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports